import type { ContentType } from '@atlassian/ai-issue-create';

import type {
	IssueCreateSidePanelActions,
	PageMode,
} from '@confluence/issue-create-side-panel/entry-points/IssueCreateSidePanelContextProvider.ts';
import type { RightSidebarContextType } from '@confluence/page-layout-context';

import { createSingleJiraWorkItemHandle } from './jiraWorkCreateHandlers.ts';

type CreateJiraWorkItemActionsProps = {
	activeSelection?: Selection | null;
	completeKey?: string;
	container: any;
	contentId?: string;
	contentType?: ContentType;
	lastModified?: string | null;
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	pageMode: PageMode;
};

export const jiraWorkItemCreateActions = ({
	activeSelection,
	// completeKey, prop that will be used later in later work item creation modes added
	container,
	contentId,
	contentType,
	lastModified,
	rightSidebarContext,
	actions,
	pageMode,
}: CreateJiraWorkItemActionsProps) => {
	// switch here eventually for different jira work item create modes
	if (contentId) {
		createSingleJiraWorkItemHandle({
			actions,
			rightSidebarContext,
			activeSelection,
			container,
			contentId,
			contentType,
			lastModified,
			pageMode,
		});
	}
};
